// @flow
import { ROLE } from '.';
import { checkIsOpenedGroup, getFocusGroupParticipant, getGroupList, getGroupParticipant, getStartGroup } from '../../group';
import { getCurrentMode, videoLayoutMode } from '../../video-layout-mode';
import { getGroupId } from '../conference';
import { indexRole, PARTICIPANT_STATUS, PARTICIPANT_STATUS_INDEX } from './constants';

// local 참가자
export function getLocalParticipant(state) {
    const { local } = state['features/base/participants'];

    return local;
}

// local 참가자 user_uuid
export function getLocalParticipantId(state) {
    const local = getLocalParticipant(state);
    return local ? local.user_uuid : null;
}

// user_uuid로 사용자 검색 
export function getParticipantById(state, user_uuid) {
    const { local, remote } = state['features/base/participants'];

    let particiapnt = remote.get(user_uuid);
    if (!particiapnt) {
        const local = getLocalParticipant(state);
        if (local && local.user_uuid === user_uuid) particiapnt = local; 
    }
    
    return particiapnt;
}

// bridge_session_id 사용자 검색 
export function getMemberIdByJitisiId(state, bridge_session_id) {
    const { bridgeParticipant } = state['features/base/participants'];
    let user_uuid;
    bridgeParticipant.forEach((bId, user_id) => {
        if (bId === bridge_session_id) {
            user_uuid = user_id;
        }
    });
    
    return user_uuid;
}

// user_uuid로 bridge_session_id 검색 
export function getJitsiIdByMemberId(state, user_uuid) {
    const { bridgeParticipant } = state['features/base/participants'];
    const bridge_session_id = bridgeParticipant.get(user_uuid);
    
    return bridge_session_id;
}

// 현재 방 참가자 가져오기 
export function getParticipantCount(state) {
    const particiapnt = getRemoteParticipantsByStatus(state);
    
    return particiapnt.length + 1;
}

// 참가자 닉네임 가져오기 
export function getParticipantDisplayName(state, user_uuid) {
    const participant = getParticipantById(state, user_uuid);

    try {
        return participant.nickname;       
    } catch (err){
        return 'user_name';
    }
}

// 모든 참가자 목록 (메인 회의방)
export function getRemoteAllParticipants(state) {
    const { remote } = state['features/base/participants'];

    return remote;
}

// local 사용자 제외 하고 참가자 목록 가져오기 
export function getRemoteParticipants(state) {
    try {
        const groupId =  getGroupId(state);
        
        const remoteParticipants = getRemoteAllParticipants(state);
        
        let items = [];
        if (groupId === "") {
            // 그룹 전체 사용자 
            const groupParticipant = getGroupParticipant(state, true);

            // 시작된 그룹에 포함 되어있지 않은 경우 사용자의 그룹 아이디는 로비 
            remoteParticipants.forEach(p => {
                const particiapnt = groupParticipant.find(g => g.user_id === p.user_uuid);
                if (particiapnt) items.push({ ...p, group_id: particiapnt.group_id });
                else items.push({ ...p, group_id: "" });
            });
        } else {
            // 현재 내가 속한 그룹방의 사용자들 가져옴 
            const groupParticipant = getFocusGroupParticipant(state, groupId, true);
            groupParticipant.map(g => {
                const particiapnt = [ ...remoteParticipants.values() ].find(r => r.user_uuid === g.user_id );
        
                items.push({ ...particiapnt, group_id: groupId });
            });
        }   

        return items;
    } catch (err) {
        console.log(err)
        return new Array();
    }
}

// local 사용자 제외 하고 참가자 목록 가져오기 + 상태로 가져옴 (occupied, vacated)
export function getRemoteParticipantsByStatus(state, status = PARTICIPANT_STATUS.OCCUPIDE) {
    const particiapnts = getRemoteParticipants(state);

    return status ? particiapnts.filter(p => p.status === status) : particiapnts;
}

// 사용자 sort 
export function getSortedRemoteParticipantsByStatus(state, status = PARTICIPANT_STATUS.OCCUPIDE) {
    const particiapnts = getRemoteParticipantsByStatus(state, status);
    const startGroup = getStartGroup(state);
    const currentGropuId = getGroupId(state);
    
    particiapnts        
        .sort((a, b) => {
            if (startGroup) {
                if ( currentGropuId === a.group_id) return -1;
                else return 1;
            }
            return 1;            
        })
        .sort((a, b) => indexRole.indexOf(a.role) - indexRole.indexOf(b.role))
        .sort((a, b) => PARTICIPANT_STATUS_INDEX.indexOf(a.status) - PARTICIPANT_STATUS_INDEX.indexOf(b.status));

    return particiapnts;
}

// 현재 방에 입장한 사용자의 session bridge id 리스트 가져오기 
export function getSortedParticipantJitsiIds(state) {
    const particiapnt = getRemoteParticipants(state);
    const { bridgeParticipant } = state['features/base/participants'];
    
    let items = new Array();
    const currentGropuId = getGroupId(state);
    particiapnt.map(p => {
        const isShow = checkIsOpenedGroup(state, p.group_id);
        if (isShow || p.group_id === currentGropuId) {
            const bridge_session_id = bridgeParticipant.get(p.user_uuid);
            bridge_session_id && items.push(bridge_session_id);
        }
    });

    return items;
}

// 스피커 사용자 반환
export function getDominantSpeakerParticipant(stateful) {
    const { dominantSpeaker } = state['features/base/participants'];

    if (!dominantSpeaker) return undefined;

    return getParticipantById(state, dominantSpeaker);
}

// 사용자가 host 확인
export function isParticipantModerator(state, user_uuid) {
    const { hostParticipant } = state['features/base/participants'];

    user_uuid = user_uuid ? user_uuid : getLocalParticipantId(state);
    return hostParticipant.has(user_uuid) ? true : false;
}

// 핀 사용자 
export function getPinnedParticipantsByStatus(state, isPin, status = PARTICIPANT_STATUS.OCCUPIDE) {
    try {
        // 현재 방에 들어와 있는 사용자 
        const remote = getRemoteParticipantsByStatus(state, status);

        // 로컬 사용자 
        const local = getLocalParticipant(state);
        
        // 방 사용자 + 로컬 사용자 
        let particiapnt = [ ...remote, local ];

        const currentGropuId = getGroupId(state);
        const mode = getCurrentMode(state);
        if (mode === videoLayoutMode.voice) {
            // 스피커 사용자 
            const { dominantSpeaker } = state['features/base/participants'];
            const index = particiapnt.findIndex(p => p.user_uuid === dominantSpeaker);
            if (index !== -1) particiapnt.splice(index, 1);
        }

        let items = new Array();
        particiapnt.map(p => {
            const isShow = checkIsOpenedGroup(state, p.group_id);
            if (isShow || p.group_id === currentGropuId) { 
                if (p.pinned === isPin) items.push(p);
            }            
        });
        return items;
    } catch {
        return new Array();
    }    
}

// 핀 사용자 sort
export function getSortedPinnedParticipantsByStatus(state, isPinned, status = PARTICIPANT_STATUS.OCCUPIDE) {
    // 현재 방에 들어와 있는 사용자 
    const particiapnt = getPinnedParticipantsByStatus(state, isPinned, status);

    particiapnt.sort((a, b) => b.entryTime - a.entryTime)
        .sort((a, b) => a.pinned === b.pinned ? 0 : a.pinned? -1 : 1 )
        .sort((a, b) => a.local === b.local ? 0 : a.local? -1 : 1 );

    return particiapnt;
}

// 녹화중인 사용자 
export function getSortedRecordingParticipants(state) {
    const recordParticipant = state['features/base/participants'].recordParticipant;

    const items = [];
    recordParticipant.forEach(user_uuid => {
        const participant = getParticipantById(state, user_uuid);
        items.push(participant);
    });

    items.sort((a, b) =>
        a.nickname.localeCompare(b.nickname)
    );

    return items;
}

export function getRecordingParticipantsCount(state) {
    const recordParticipant = state['features/base/participants'].recordParticipant;

    return recordParticipant?.size || 0;
}

// 사용자 아이디만 가져오기 
export function getdParticipantIds(state, status) {
    const particiapnt = getSortedRemoteParticipantsByStatus(state, status);
    return particiapnt.map(p => p.user_uuid);
}

// 현재 그룹에 속한 사용자만 
export function getdParticipantIdsInGroup(state) {
    const particiapnt = getSortedLayoutParticipant(state, false);
    return particiapnt.map(p => p.user_uuid);
}

// 
export function checkInGroupByUserId(state, user_id) {
    const particiapnt = getGroupParticipant(state, true);
    return particiapnt.find(p => p.user_id === user_id);
}

// 핀 사용자 아이디만 가져오기 
export function getPinnedParticipantIds(state, status) {
    const particiapnt = getPinnedParticipantsByStatus(state, status);
    const participantIds = particiapnt.map(p => p.user_uuid);

    return participantIds;
}

// 화면 보이는 멤버 리스트 
export function getSortedLayoutParticipant(state, includePin) {
    const local = getLocalParticipant(state);
    const remote = getRemoteParticipantsByStatus(state);

    let particiapnt = [ local, ...remote ];
    let dominantSpeaker = null;

    const mode = getCurrentMode(state);
    if (mode === videoLayoutMode.voice) {
        dominantSpeaker = state['features/base/participants'].dominantSpeaker;
    }
    particiapnt = particiapnt.filter( p => {
        if (!p) return false;
        if (p.user_uuid === dominantSpeaker) return false;
        if (p.local) return true;
        
        else {
            const isShow = checkIsOpenedGroup(state, p.group_id);
            return isShow && p.status === PARTICIPANT_STATUS.OCCUPIDE ? true : false;
        }
    });    
    
    if (!includePin) particiapnt = particiapnt.filter(p => p.pinned === false);
    

    particiapnt.sort((a, b) => b.entryTime - a.entryTime)
        .sort((a, b) => a.pinned === b.pinned ? 0 : a.pinned? -1 : 1 )
        .sort((a, b) => a.local === b.local ? 0 : a.local? -1 : 1 );

    return particiapnt;
}

// 멤버 리스트 
export function getLayoutParticipant(state) {
    const local = getLocalParticipant(state);
    const remote = getRemoteParticipantsByStatus(state);

    let particiapnt = [ local, ...remote ];
    particiapnt = particiapnt.filter( p => {
        if (!p) return false;
        if (p.local) return true;
        else {
            const isShow = checkIsOpenedGroup(state, p.group_id);
            return isShow && p.status === PARTICIPANT_STATUS.OCCUPIDE ? true : false;
        }
    });    
    
    return particiapnt;
}

// 채팅 사용자 가져오기 
export function getChatParticipant(state) {
    const remote = getRemoteParticipantsByStatus(state);

    let particiapnt = new Map();

    remote.map(p => {
        if (!p) return false;
        else {
            const isShow = checkIsOpenedGroup(state, p.group_id);
            if (isShow && p.status === PARTICIPANT_STATUS.OCCUPIDE) {
                particiapnt.set(p.user_uuid, p);
            }
        }
    });

    return particiapnt
}


export function checkRoleLevel(state, role) {
    const localRole = getLocalParticipant(state).role;

    if (indexRole.indexOf(localRole) > indexRole.indexOf(role)) return false;
    return true;
}

export function getUserIDByMemberId(state, member_uuid) {
    const { remote } = state['features/base/participants'];

    let user = null;
    const participant = remote.forEach(r => {
        if (r.member_uuid === member_uuid) user = r;
    });

    return user && user.user_uuid;
}

// check 나의 그룹 권한 
export async function checkMeetingRole(localId, groupID = "") {
    let myRole = ROLE.PARTICIPANT;
    try {
        const { complete, message } = await APP.API.getAllParticipant({ user_id: localId, groupID: groupID });

        if (complete) {
            myRole = message[0].role.name;
        }
        return myRole;
    } catch {
        return myRole;
    }    
}


// 그룹 권한을 가지는 사용자 확인
export function checkGroupPermission(role) {
    return [ROLE.HOST].indexOf(role) !== -1 ? true : false;
}

export function checkCloseGroupPermission(role) {
    return [ROLE.HOST, ROLE.MANAGER].indexOf(role) !== -1 ? true : false;
}